import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.gRiKLf',
    defaultMessage: 'Apps',
  },
  description: {
    id: 'studio.qqW9Os',
    defaultMessage: 'Browse the apps that are built using Appsemble',
  },
});
